import { ThemeBrandColors } from "../../types";

export const CovidDiseaseEducationBrand: ThemeBrandColors = {
  "color-brand-50": "#F2F2FB",
  "color-brand-100": "#E7E7F8",
  "color-brand-200": "#D4D3F2",
  "color-brand-300": "#B9B7EA",
  "color-brand-400": "#A39ADF",
  "color-brand-500": "#9081D3",
  "color-brand-600": "#8167C4",
  "color-brand-700": "#6F57AB",
  "color-brand-800": "#544381",
  "color-brand-900": "#3B2C6A",
  "color-brand-950": "#1E2846"
};
